import {all, call, put, select, takeEvery, takeLatest} from "redux-saga/effects";
import {
  apiCtpTypes,
  apiDeleteOneLesson, apiGetExamStatement,
  apiGetOneLesson, apiGetPlanTask, apiGetPlanTest,
  apiLesson, apiOneLesson, apiPostPlanTest, apiPostTestProcess, apiTestImportFromLibrary,
} from "./api";
import {
  addLessonAction,
  addLessonActionDone,
  addLessonActionFail,
  addOneLessonAction,
  addOneLessonActionDone,
  addOneLessonActionFail,
  addQuestionAnswerAction,
  addQuestionAnswerActionDone,
  addQuestionAnswerActionFail,
  copyPlanAction,
  copyPlanActionDone,
  copyPlanActionFail,
  deleteOneLessonAction,
  deleteOneLessonActionDone,
  deleteOneLessonActionFail,
  deleteTabInnerContentAction,
  deleteTabInnerContentActionDone,
  deleteTabInnerContentActionFail,
  editLessonAction,
  editLessonActionDone,
  editLessonActionFail,
  getCurrentPlanByCtpAction,
  getLessonAction,
  getLessonActionDone,
  getLessonActionFail,
  getPlanListAction,
  getPlanListActionDone,
  getPlanListActionFail,
  getOneCtpAction,
  getOneCtpActionDone,
  getOneCtpActionFail,
  getOneLessonAction,
  getOneLessonActionDone,
  getOneLessonActionFail,
  getQuestionAnswerAction,
  getQuestionAnswerActionDone,
  getQuestionAnswerActionFail,
  materialResultSendAction,
  materialResultSendActionDone,
  materialResultSendActionFail,
  taskResultSendAction,
  taskResultSendActionDone,
  taskResultSendActionFail,
  testBegin,
  testBeginDone,
  testBeginFail,
  testEnd,
  testEndDone,
  testEndFail,
  testImportFromLibrary,
  testImportFromLibraryDone,
  testImportFromLibraryFail,
  testResultAction,
  testResultActionDone,
  testResultActionFail,
  updateTabInnerContentAction,
  updateTabInnerContentActionDone,
  getPlansCurrentCtpListActionDone,
  getPlansCurrentCtpListActionFail,
  updateTabInnerContentActionFail,
  getPlansCurrentFilterActionDone,
  getPlansCurrentFilterActionFail,
  getPlansCurrentCtpListAction,
  getPlansCurrentFilterAction,
  setStudentListActionDone,
  setStudentListActionFail,
  setStudentListAction,
  getOneTaskAction,
  getOneTaskActionDone,
  getOneTaskActionFail,
  testsImportAction,
  getExamStatementActionDone, getExamStatementActionFail, getExamStatementAction,
} from "./actions";
import {PayloadAction} from "@reduxjs/toolkit";
import {apiSetForm} from "../../common/api";
import {message, Modal} from "antd";
import {JOURNAL_YEAR} from "../../../constants";
import {getPeriodFlow} from "../../common/saga";
import {selectStore} from "../../selector";
import {RootState} from "../../index";
import {t} from "i18next";
import {v4 as uuidv4} from "uuid";

export function* getOneCtpFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiOneLesson, payload);
    if (data.data) {
      yield put(getOneCtpActionDone(data.data));

      return data.data
    }
  } catch (e) {
    console.warn(e);
    yield put(getOneCtpActionFail());
  }
}

function* getPlanListFlow({ payload }: PayloadAction<any>): any {
  const {profile: {userProfile: userProfileState}}: RootState = yield select(selectStore)

  const years = [
    JOURNAL_YEAR.PREV,
    JOURNAL_YEAR.CURRENT,
    JOURNAL_YEAR.NEXT,
  ]

  const adminType = [
    {
      key: `filter-filter-1`,
      name: 'filter',
      value: 'my',
      label: t('common:private'),
      url: 'ctp',
    },
    {
      key: `filter-is_shared-2`,
      name: 'is_shared',
      value: 1,
      label: t('common:public'),
      url: 'ctp',
    },
    {
      key: `filter-type-3`,
      name: 'type',
      value: 0,
      label: t('common:sdot'),
      url: 'ctp',
    },
    ...(userProfileState.data?.isCollegeAdmin ? [
      {
        key: `filter-filter-4`,
        name: 'filter',
        value: 'all',
        label: t('common:all'),
        filter_url: 'ctp-filter',
        url: 'ctp',
      }
    ] : [])
  ]

  try {
    const yearsData = yield all(years?.map((item: any) => {
      return call(apiCtpTypes, {year: item})
    }))

    if(yearsData){
      let res = years?.map((first: any, firstIndex: any) => {
        return {
          label: `${first}-${Number(first) + 1}`,
          key: `year-${first}-${firstIndex}`,
          name: 'year',
          value: first,
          secondValue: Number(first) + 1,
          children: yearsData[firstIndex]?.data?.filter((second: any, secondIndex: any) => second.value !== 3)?.map((second: any, secondIndex: any) => {
            return {
              label: second.label,
              key: `type-${second.value}-${secondIndex}`,
              name: 'type',
              value: second.value,
              children: adminType
            }
          })
        }
      })

      yield put(getPlanListActionDone(res))
    }
  } catch (e) {
    console.warn(e);
    yield put(getPlanListActionFail())
  }
}

function* getPlanCurrentCtpListFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiSetForm, payload);
    if (data.data) {
      yield put(getPlansCurrentCtpListActionDone(data.data));
    }
  } catch (e) {
    console.error(e);
    yield put(getPlansCurrentCtpListActionFail(payload));
  }
}

function* getPlanCurrentCtpFilterFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    yield put(getPlansCurrentFilterActionDone(payload?.data))
  }

  if(isFail){
    yield put(getPlansCurrentFilterActionFail(payload))
  }
}

function* getLessonFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiLesson, payload);
    if (data.data) {
      yield put(getLessonActionDone(data.data));
    }
  } catch (e) {
    console.warn(e);
    yield put(getLessonActionFail());
  }
}

export function* getOneLessonFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetOneLesson, payload);
    if (data.data) {
      yield put(getOneLessonActionDone(data.data));
    }
  } catch (e) {
    console.warn(e);
    yield put(getOneLessonActionFail());
  }
}

function* addLessonFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed


  if (isDone) {
    if(payload.data.theme){
      message.success(`Урок "${payload.data.theme}" успешно добавлен!`)
    }else{
      message.success(`Урок успешно добавлен!`)
    }
    yield put(addLessonActionDone(payload));
  }

  if (isFail) {
    yield put(addLessonActionFail(payload));
  }
}

function* deleteOneLessonFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiDeleteOneLesson, payload);
    if (data.data) {
      yield put(deleteOneLessonActionDone(data.data));
    }
  } catch (e) {
    console.warn(e);
    yield put(deleteOneLessonActionFail());
  }
}

function* addOneLessonFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    let {form, ...all} = payload.data
    let data = {...all}

    yield put(addOneLessonActionDone({...payload, data}));
    payload.data.handleClose()
    message.success(`${payload.data.name} успешно добавлен!`)
  }

  if (isFail) {
    let errArr = payload.error?.response?.data

    console.log('errArr', payload.error)

    payload?.data?.form?.setFields(errArr?.map((item: any) => {
      return {
        name: item?.field,
        value: null,
        errors: [item?.message]
      }
    }))

    yield put(addOneLessonActionFail(payload));
  }
}

function* editOneLessonFlow({payload}: PayloadAction<any>):any{
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    yield put(editLessonActionDone(payload))

    // @ts-ignore
    yield call(getOneLessonFlow, {payload: {lesson_id: payload.data?.lesson_id}})
  }

  if(isFail){
    yield put(editLessonActionFail(payload))
  }
}

function* addQuestionAnswerFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiPostPlanTest, payload);
    if (data.data) {
      yield put(addQuestionAnswerActionDone(data.data));
      message.success(t('common:successSave'))
    }
  } catch (e) {
    console.warn(e);
    yield put(addQuestionAnswerActionFail());
    // @ts-ignore
    e?.response?.data?.map((item: any) => {
      message.error(item?.message)
    })
  }
}

export function* getQuestionAnswerFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetPlanTest, payload);
    if (data.data) {
      let res = {
        ...data.data,
        questions: data.data?.questions?.map((item: any) => ({
          ...item,
          key: uuidv4()
        }))
      }
      yield put(getQuestionAnswerActionDone(res));
      return res
    }
  } catch (e) {
    console.warn(e);
    yield put(getQuestionAnswerActionFail());
  }
}

function* copyPlanFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    message.success('Планы скопировались успешно!')
    yield put(copyPlanActionDone(payload));
  }

  if (isFail) {
    yield put(copyPlanActionFail(payload));
  }
}

function* updateTabInnerContentFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    // @ts-ignore
    let {form, ...all} = payload.data
    let data = {...all}

    yield put(updateTabInnerContentActionDone({...payload, data}));

    payload.data.handleClose()

    message.success(t('common:successChanged'))
  }

  if(isFail){
    let errArr = payload.error?.response?.data

    // for(let i = 0; i < errArr?.length; i++){
    //   message.error(errArr[i]?.message)
    // }

    payload?.data?.form?.setFields(errArr?.map((item: any) => {
      return {
        name: item?.field,
        value: null,
        errors: [item?.message]
      }
    }))

    // @ts-ignore
    yield put(updateTabInnerContentActionFail(payload));
  }
}

function* deleteTabInnerContentFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    // @ts-ignore
    yield put(deleteTabInnerContentActionDone(payload));
  }

  if(isFail){
    // @ts-ignore
    yield put(deleteTabInnerContentActionFail(payload));
  }
}

function* testResultFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    // @ts-ignore
    yield put(testResultActionDone(payload.data.question));
  }

  if(isFail){
    // @ts-ignore
    yield put(testResultActionFail(payload));
  }
}

function* taskResultSendFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    message.success('Задание успешно отправлено!')
    // @ts-ignore
    yield put(taskResultSendActionDone(payload));

    // @ts-ignore
    yield call(getOneLessonFlow, {payload: {lesson_id: payload?.data?.lesson_id}})
  }

  if(isFail){
    // @ts-ignore
    yield put(taskResultSendActionFail(payload));
  }
}


function* materialResultSendFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    message.success('Статус успешно обновлен!')
    yield put(materialResultSendActionDone(payload));

    // @ts-ignore
    yield call(getOneLessonFlow, {payload: {lesson_id: payload?.data?.lesson_id}})
  }

  if(isFail){
    yield put(materialResultSendActionFail(payload));
  }
}

function* getCurrentPlanByCtpFlow({payload}: PayloadAction<any>): any {
  try {
    // @ts-ignore
    let ctp = yield call(getOneCtpFlow, {payload: payload})
    // @ts-ignore
    let periodByGroup = yield call(getPeriodFlow, {payload: {year: ctp?.year, group_id: ctp?.group_id}})


    if(periodByGroup?.length){

    } else {
      // @ts-ignore
      let period = yield call(getPeriodFlow, {payload: {year: ctp?.year}})

    }

  } catch (e) {

  }
}


function* testBeginFlow({payload}: PayloadAction<any>): any {
  try {
    // @ts-ignore
    const question = yield call(getQuestionAnswerFlow, {payload: payload.test_id})

    if(question){
      let body = {
        act: 'begin',
        lesson_id: payload.lesson_id,
        th: question?.hash,
        test_password: payload?.test_password
      }

      const data = yield call(apiPostTestProcess, body);

      if (data.data) {
        yield put(testBeginDone({data: {...data.data, ...body}}));
        payload.onSuccess()
      }
    }

  } catch (e: any) {
    yield put(testBeginFail());

    if(Array.isArray(e?.response?.data)){
      e?.response?.data?.map((item: any) => {
        message.error(item?.message)
      })
    }
  }
}

function* testImportFromLibraryFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiTestImportFromLibrary, payload);
    if (data.data) {
      yield put(testImportFromLibraryDone(data.data));
    }
  } catch (e) {
    console.warn(e);
    yield put(testImportFromLibraryFail());
  }
}

function* testEndFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed
  const {profile: {userProfile: userProfileState}}: RootState = yield select(selectStore)

  if(isDone){
    yield put(testEndDone(payload));

    Modal.warning({
      title: t('common:testResult'),
      icon: null,
      centered: true,
      className: 'modal-restore',
      content: payload.data.successContent(`${userProfileState.data.firstname} ${userProfileState.data.lastname}`, payload.data.resultText),
      okText: 'Закрыть',
      okButtonProps: {
        type: 'default',
      },
      onOk: () => {
        payload.data.successHandler()
      },
    })
  }

  if(isFail){
    yield put(testEndFail(payload));
  }
}

function* setStudentListFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone){
    message.success(t('common:successChanged'))
    yield put(setStudentListActionDone(payload));
  }

  if(isFail){
    yield put(setStudentListActionFail(payload));

    for(let i = 0; i < payload?.error?.response?.data?.length; i++){
      message.error(payload?.error?.response?.data[i]?.message)
    }
  }
}

function* getOneTaskFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetPlanTask, payload);
    if (data.data) {
      yield put(getOneTaskActionDone(data.data));
    }
  } catch (e) {
    console.warn(e);
    yield put(getOneTaskActionFail());
  }
}

function* testsImportFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if(isDone) {
    message.info(payload?.data?.log_text)
  }

  if(isFail){
    message.error(payload?.data?.log_text)
  }
}

function* examStatementFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetExamStatement, payload);
    if (data.data) {
      window.open(data?.data?.link, "blank")

      yield put(getExamStatementActionDone(data.data));
    }
  } catch (e) {
    console.warn(e);
    yield put(getExamStatementActionFail());
  }
}


export default function* plansSaga() {
  yield takeLatest(getOneCtpAction, getOneCtpFlow);
  yield takeEvery(getPlanListAction, getPlanListFlow);
  yield takeEvery(getPlansCurrentCtpListAction, getPlanCurrentCtpListFlow);
  yield takeEvery(getPlansCurrentFilterAction, getPlanCurrentCtpFilterFlow);
  yield takeLatest(getLessonAction, getLessonFlow);
  yield takeLatest(getOneLessonAction, getOneLessonFlow);
  yield takeLatest(addLessonAction, addLessonFlow);
  yield takeLatest(editLessonAction, editOneLessonFlow);
  yield takeLatest(deleteOneLessonAction, deleteOneLessonFlow);
  yield takeLatest(addOneLessonAction, addOneLessonFlow);
  yield takeLatest(addQuestionAnswerAction, addQuestionAnswerFlow);
  yield takeLatest(getQuestionAnswerAction, getQuestionAnswerFlow);
  yield takeLatest(copyPlanAction, copyPlanFlow);
  yield takeLatest(updateTabInnerContentAction, updateTabInnerContentFlow);
  yield takeLatest(deleteTabInnerContentAction, deleteTabInnerContentFlow);
  yield takeLatest(testResultAction, testResultFlow);
  yield takeLatest(taskResultSendAction, taskResultSendFlow);
  yield takeLatest(materialResultSendAction, materialResultSendFlow);
  yield takeLatest(getCurrentPlanByCtpAction, getCurrentPlanByCtpFlow);
  yield takeLatest(testBegin, testBeginFlow);
  yield takeLatest(testImportFromLibrary, testImportFromLibraryFlow);
  yield takeLatest(testEnd, testEndFlow);
  yield takeLatest(setStudentListAction, setStudentListFlow);
  yield takeLatest(getOneTaskAction, getOneTaskFlow);
  yield takeLatest(testsImportAction, testsImportFlow);
  yield takeLatest(getExamStatementAction, examStatementFlow);
}

